import {
  ApiChartPayload,
  ApiChartResponse,
  ApiChartYAxisKey,
} from "@incendium/api";
import { IChart } from "Interfaces";
import { parseChartAttributeToPrimaryFilters } from "Helpers/analytics";

export const parseChartFromResponse = (res: ApiChartResponse): IChart => {
  // fe chart interaface and generated interface slightly diverge, we handle this here
  return {
    ...res,
    yAxisKeys: (res.yAxisKeys || []).map((v: ApiChartYAxisKey) => v),
    attributes: parseChartAttributeToPrimaryFilters(res.attributes || []),
  };
};

export const parseChartPayloadToIChart = (res: ApiChartPayload): IChart => {
  return {
    ...res,
    yAxisKeys: (res.yAxisKeys || []).map((v: ApiChartYAxisKey) => v),
    attributes: parseChartAttributeToPrimaryFilters(res.attributes || []),
  };
};

export const parseIChartToChartPayload = (chart: IChart): ApiChartPayload => {
  return {
    ...chart,
    yAxisKeys: (chart.yAxisKeys || []).filter(
      (v) => typeof v !== "string",
    ) as ApiChartYAxisKey[],
  };
};
